import { Pipe, PipeTransform } from '@angular/core';
import { RouterTypeDto } from '../api/core';
import { isNil } from '@jsverse/transloco';

@Pipe({
    name: 'liebherrDisplayRouterType',
})
export class DisplayRouterTypePipe implements PipeTransform {
    transform(id: number, routerTypes: RouterTypeDto[]): any {
        const routerType = routerTypes.find((r) => r.id === id);
        return !isNil(routerType?.name) ? `${routerType?.name?.toUpperCase()} (${routerType?.vendor?.toUpperCase() || '-'})` : undefined;
    }
}
